export const APP_SNACKBAR_SHOW = 'APP_SNACKBAR_SHOW'
export const APP_SNACKBAR_HIDE = 'APP_SNACKBAR_HIDE'

export const showAppSnackbar = message => ({ type: APP_SNACKBAR_SHOW, message })
export const hideAppSnackbar = () => ({ type: APP_SNACKBAR_HIDE })
